'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRouter = require('react-router');

var _components = require('components');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPrice = function getPrice(name, priceMap) {
  return _underscore2.default.indexBy(priceMap, 'name')[name].price;
};

var getPackHeaderSwitchButtonClasses = function getPackHeaderSwitchButtonClasses(v, value, styles) {
  var _classnames;

  return (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.PackHeaderSwitch__button, true), (0, _defineProperty3.default)(_classnames, styles['PackHeaderSwitch__button--active'], v == value), _classnames));
};

var PackHeaderSwitch = function PackHeaderSwitch(_ref) {
  var styles = _ref.styles,
      id = _ref.id,
      value = _ref.value;
  return _react2.default.createElement(
    'div',
    { className: styles.PackHeaderSwitch },
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/packs/' + id, className: styles.PackHeaderSwitch__button, activeClassName: styles['PackHeaderSwitch__button--active'] },
      'View Details'
    ),
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/megascans/library/packs/' + id, className: styles.PackHeaderSwitch__button, activeClassName: styles['PackHeaderSwitch__button--active'] },
      'View Assets'
    )
  );
};

var PackHeader = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PackHeader, _React$Component);

  function PackHeader(props) {
    (0, _classCallCheck3.default)(this, PackHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PackHeader.__proto__ || (0, _getPrototypeOf2.default)(PackHeader)).call(this));

    var priceMap = props.pack.priceMap;

    var _priceMap = (0, _slicedToArray3.default)(priceMap, 1),
        firstPriceMap = _priceMap[0];

    var id = firstPriceMap.id;


    _this.state = {
      currentPriceMapId: id,
      tooltip: false
    };
    return _this;
  }

  (0, _createClass3.default)(PackHeader, [{
    key: 'onResolutionChange',
    value: function onResolutionChange(e) {
      var priceMap = this.props.pack.priceMap;


      this.setState({ currentPriceMapId: e.currentTarget.value });
    }
  }, {
    key: 'renderBuyOptions',
    value: function renderBuyOptions() {
      var _this2 = this;

      var styles = require('./PackHeader.scss');
      var _props = this.props,
          pack = _props.pack,
          loggedIn = _props.loggedIn;
      var id = pack.id,
          priceMap = pack.priceMap;
      var currentPriceMapId = this.state.currentPriceMapId;


      var currentPriceMap = priceMap.find(function (p) {
        return p.id == currentPriceMapId;
      });
      var license = currentPriceMap.license,
          price = currentPriceMap.price;


      var buyLinkTo = '/packs/' + id + '/' + currentPriceMapId + '/purchase';

      var pricesGroupedByLicense = _underscore2.default.groupBy(priceMap, function (p) {
        return p.license;
      });

      var isOnSale = !!currentPriceMap && !!currentPriceMap.comparePrice && currentPriceMap.discount;
      var buyButtonLabel = isOnSale ? 'Buy' : 'Buy for $' + price;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _components.Select,
            {
              onChange: this.onResolutionChange.bind(this),
              className: styles.DownloadResolutions,
              name: 'name',
              id: "pack-settings-resolution" },
            _underscore2.default.values(pricesGroupedByLicense).map(function (group, i, l) {
              return i < l.length - 1 ? [group.map(function (_ref2) {
                var id = _ref2.id,
                    name = _ref2.name;
                return _react2.default.createElement(
                  'option',
                  { value: id },
                  '' + name
                );
              }), _react2.default.createElement(
                'option',
                { disabled: true },
                '\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013'
              )] : group.map(function (_ref3) {
                var id = _ref3.id,
                    name = _ref3.name;
                return _react2.default.createElement(
                  'option',
                  { value: id },
                  '' + name
                );
              });
            })
          ),
          isOnSale && _react2.default.createElement(
            'div',
            { className: styles.Pack__comparePrice },
            '$' + currentPriceMap.comparePrice
          ),
          isOnSale && _react2.default.createElement(
            'div',
            { className: styles.Pack__price },
            '$' + price
          ),
          _react2.default.createElement(_components.Button, {
            className: styles.BuyButton,
            primary: true,
            link: true,
            to: buyLinkTo,
            label: buyButtonLabel,
            onMouseEnter: function onMouseEnter() {
              _this2.setState({ tooltip: true });
            },
            onMouseLeave: function onMouseLeave() {
              _this2.setState({ tooltip: false });
            } }),
          _react2.default.createElement(
            'span',
            { className: styles['Plan__details-block-info'] },
            _react2.default.createElement('img', { src: '../../icons/info.svg', onClick: function onClick() {
                _this2.context.dialogs.custom(_react2.default.createElement(_components.LicenseInfoDialog, { type: license + '-pack' }));
              } })
          )
        ),
        loggedIn && this.state.tooltip && _react2.default.createElement(_components.Tooltip, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./PackHeader.scss');
      var pack = this.props.pack;
      var id = pack.id;


      var isAcquired = pack && pack.acl != null;

      return _react2.default.createElement(
        'div',
        { className: styles.PackHeader },
        _react2.default.createElement(
          'div',
          { className: styles.PackHeader__guts },
          _react2.default.createElement(
            'div',
            { className: styles.PackHeader__details },
            _react2.default.createElement(
              'div',
              { className: styles.PackHeader__title },
              pack.name
            ),
            _react2.default.createElement(PackHeaderSwitch, { styles: styles, id: id })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.PackHeader__actions },
            !isAcquired && this.renderBuyOptions()
          )
        )
      );
    }
  }]);
  return PackHeader;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = PackHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PackHeader/PackHeader.jsx
// module id = 2699
// module chunks = 0